import React, { MouseEvent } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth0 } from '../helpers/react-auth0-spa';
import config from '../config';
import LottieLogo from "./LottieLogo";


const SNav = styled.div`
  justify-content: space-between;
  flex-direction: row;
  width: 90vw;
  height: 8vh;
  margin-top: 2vh;

  @media (orientation: landscape) {
    margin-top: 4vh;
  }
`

interface INavBarProps {}

const NavBar: React.SFC<INavBarProps> = (props) => {
  const { isAuthenticated, loginWithRedirect, logout } = useAuth0();
  const returnTo = config.baseUrl;
  const history = useHistory();
  const location = useLocation();

  const handleNav = (event: MouseEvent) => {
    history.push('/admin');
  };

  return (
    <SNav className={"NavBar"} >
      {!isAuthenticated && (
        <>
        <div>
          <LottieLogo height={'5vw'} width={'5vw'}/>
        </div>
        <div>
          <button onClick={() => loginWithRedirect({})}>Admin Log in</button>
        </div>
        </>
      )}

      {isAuthenticated && (
        <>
          <div>
            <LottieLogo height={'5vw'} width={'5vw'}/>
          </div>
          <div style={{flexDirection: 'row'}}>
            {location.pathname.match(/(\/admin\/)\S+/) && (
              <button onClick={handleNav}>Admin Home</button>
            )}
            <button onClick={() => logout({ returnTo })}>Log out</button>
          </div>
        </>
      )}
    </SNav>
  );
};

export default NavBar;
